import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import type { ActiveContactsExportPanelProps } from "../../components/ContactsTableActionsPanel/ActivatedExportPanel/ActiveContactsExportPanel";
import { ActiveContactsExportPanel } from "../../components/ContactsTableActionsPanel/ActivatedExportPanel/ActiveContactsExportPanel";
import trackingService from "../../services/tracking/trackingService";
import { selectExportDestination, selectExportVariant, selectRemainingQuota } from "../../store/selectors";
import type { ExportToExcelFn } from "../../types/exportFlow";

type CRMContactsExportPanelContainerProps = ActiveContactsExportPanelProps & {
    onSuccess: VoidFunction;
};

const CRMContactsExportPanelContainer = ({
    onSuccess,
    ...rest
}: CRMContactsExportPanelContainerProps): ReactElement => {
    const exportVariant = useSelector(selectExportVariant);
    const exportDestination = useSelector(selectExportDestination);
    const quota = useSelector(selectRemainingQuota);

    const handleExportSubmit: ExportToExcelFn = async (topNOrPairs, isSilent) => {
        if (exportDestination) {
            trackingService.trackContactsExport(topNOrPairs, exportDestination, quota);
        }

        if (exportVariant !== "crm") {
            return rest.onExportToExcel(topNOrPairs, isSilent);
        }

        return { success: true, exportedCount: 0 };
    };

    return (
        <ActiveContactsExportPanel
            {...rest}
            onExportToExcel={handleExportSubmit}
            onRefetchData={onSuccess}
        />
    );
};

export default CRMContactsExportPanelContainer;
